import React from 'react'
import { useState, useEffect, useContext, useRef, useReducer } from "react";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { db } from '../../config/firebase';
import useOutsideCloser from '../../custom hooks/clickOutsideCloser';
import { FaLeftRight } from "react-icons/fa6";

import { BsTrash3 } from "react-icons/bs";

import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  deleteDoc,
} from "firebase/firestore";

import ReactGA from "react-ga4";
import { FiSearch } from "react-icons/fi";

import { CiRead, CiUnread } from "react-icons/ci";

import Spinner from '../../components/Loading/TailSpin';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import ManageUserCheckBox from '../../components/Input/customCheckbox';
import CopyComponent from './components/Copy';
import ModalAnimation from '../../components/animations/ModalAnimation';
dayjs.extend(localizedFormat);


function ManageIndividuals({ }) {
  const navigate = useNavigate();
  const location = useLocation();

  // const { } = useContext(Context);

  const [isLoading, setIsLoading] = useState(false);

  const [usersExceptInGrp, setUsersExceptInGrp] = useState([]);
  const [fetchedGroups, setFetchedGroups] = useState([]);

  const [name1, setName1] = useState("")
  const [name2, setName2] = useState("")
  const [groupId, setGroupId] = useState("")


  const [search, setSearch] = useState("");

  useEffect(() => {

    const getGroups = async (id) => {
      setIsLoading(true)
      try {
        const collectionRef = collection(db, 'groups')
        let q = query(collectionRef, where("isIndividual", "==", true), orderBy("createdAt"), limit(50));
        // if (groupId !== "") {
        //   q = 
        // } else {
        //   q = query(collectionRef, orderBy("createdAt"), limit(50));
        // }

        const data = await getDocs(q);
        const reqData = data.docs.map((item) => {
          return {
            ...item.data(),
            id: item.id,
            isSelected: false,
            createdAt: dayjs(new Date(item.data().createdAt.seconds * 1000 + item.data().createdAt.nanoseconds / 1000000,)).format("lll"),
          }
        })
        setFetchedGroups(reqData);

        // console.log("Fetched users Data UE: ", reqData);
      } catch (error) {
        // console.log(error);
      }
      setIsLoading(false)
    }

    getGroups();
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Manage Individuals" })
  }, [])



  const handleUserSelection = (uid) => {
    setFetchedGroups((prev) => (prev.map((item) => {
      if (item.id === uid)
        return {
          ...item,
          isSelected: !item.isSelected,
        };
      else return item
    })))
  }

  const handleSelectAllUsers = (setSelectAllUser) => {
    setSelectAllUser((prev) => {

      setFetchedGroups((prevUser) => (prevUser.map((item) => ({
        ...item,
        isSelected: !prev,
      }))))

      return !prev;
    })
  }

  // Select groups to ADD USERs
  const handleGroupSelection = (id) => {
    // console.log(name);
    setUsersExceptInGrp((prev) => prev.map((item) => {
      if (item.id === id) return {
        ...item, selected: !item.selected
      }
      return item
    }
    ))
  }


  const handleGroupDeleteAll = async () => {

    try {

      for (const indvGrp of fetchedGroups.filter((item) => item.isSelected)) {
        const docRef = doc(db, 'groups', indvGrp.id);
        await deleteDoc(docRef);
      }
      setFetchedGroups((prev) => (prev.filter((item) => (!item.isSelected))))
      setShowDeleteAllConfirmationPopup(false)

      // console.log();
    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  }

  const handleGroupDelete = async (groupId) => {

    try {
      const docRef = doc(db, 'groups', groupId);
      await deleteDoc(docRef);


      setFetchedGroups((prev) => (prev.filter((item) => (item.id !== groupId))))
      setShowDeleteConfirmationPopup(false)
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  }

  //-------------------------------------------------| ALL POPUPS |-------------------------------------------------
  const confirmationRef = useRef(null);
  const confirmationAllRef = useRef(null);

  // const [showDeleteAllConfirmationPop, setShowDeleteConfirmationPopup] = useState(false);
  // useOutsideCloser(confirmationRef, setShowDeleteConfirmationPopup);

  const [showDeleteConfirmationPop, setShowDeleteConfirmationPopup] = useState(false);
  useOutsideCloser(confirmationRef, setShowDeleteConfirmationPopup);

  const [showDeleteAllConfirmationPop, setShowDeleteAllConfirmationPopup] = useState(false);
  useOutsideCloser(confirmationAllRef, setShowDeleteAllConfirmationPopup);



  if (true)
    return (
      <div className="relative w-full flex flex-col h-full">

        {/* <TiArrowBackOutline className='w-5 h-5 '/> */}

        <div className="relative font-semibold text-xl text-headPrimary bg-lightPrimary h-[50px] w-full flex items-center justify-center ">

          <div className="absolute left-6 top-0 bottom-0 my-auto h-fit w-[90px] md:w-[150px] ">
            <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[20px] md:h-[28px] w-full flex-grow items-left justify-start gap-2 rounded-md px-1.5 py-0.5">
              <div className="flex h-full w-full items-center font-normal ">
                <FiSearch
                  className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                <input
                  onChange={(e) => {
                    setSearch((e.target.value))
                  }}
                  value={search}
                  type="text"
                  placeholder={window.innerWidth < 600 ? "Search" : "Search for Individuals"}
                  className="block ml-0 px-2 h-auto w-full bg-white text-xs md:text-sm text-gray-700 outline-none placeholder:!text-gray-400"
                />
              </div>

            </div>
          </div>
          <div className="absolute right-6 top-0 bottom-0 my-auto h-fit w-fit ">

            <BsTrash3
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteAllConfirmationPopup(true);
              }}
              className='w-8 h-4 cursor-pointer text-gray-600 hover:text-headPrimary' />
          </div>

          <div className="">Manage Individuals</div>
        </div>


        <div className="h-[calc(100%-112px)] w-full py-2 px-2 overflow-y-auto">

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-7 gap-3.5 md:gap-5 p-3 max-h-full">


            {fetchedGroups.filter((item) => (search === "" || item?.users[0]?.displayName?.toLowerCase().includes(search.toLowerCase())
              || item?.users[1]?.displayName?.toLowerCase().includes(search.toLowerCase())))

              .map((item, ind) => (
                <div className={`w-full flex flex-col items-center  bg-lightPrimary p-2 pl-3 pr-3 md:pr-1 gap-3 rounded-lg `}>
                  <div className="w-full flex items-center justify-between">

                    <div className="flex items-center" >
                      <ManageUserCheckBox onChange={() => handleUserSelection(item.id)} checked={item.isSelected} />

                      <div key={"Ind"} className="flex items-center w-full px-1.5 py-[2px] text-xs font-normal bg-white border gap-2 rounded">
                        {/* <div className=""></div> */}

                        <Link to='/G' target="_blank" className="hover:underline"
                          onClick={() => { localStorage.setItem("displayName", item?.users[0]?.displayName); localStorage.setItem("uid", item?.users[0]?.uid) }} >
                          {item?.users[0]?.displayName}
                        </Link>

                        <FaLeftRight className='w-3.5 h-3.5 text-headPrimary' />

                        <Link to='/G' target="_blank" className="hover:underline"
                          onClick={() => { localStorage.setItem("displayName", item?.users[1]?.displayName); localStorage.setItem("uid", item?.users[1]?.uid) }} >
                          {item?.users[1]?.displayName}
                        </Link>

                      </div>
                    </div>

                    <CopyComponent toCopy={item.id} />
                  </div>

                  {/* <div className="flex w-full overflow-x-auto gap-2 ">
                    {item.users.map((user, ind) => (
                      <div className={`relative flex flex-col px-1 pr-2.5 w-[90px] ${ind % 2 ? "bg-[#f7f2fe]" : "bg-[#f1fff8]"}`}>

                        <div className="text-xs w-full truncate ">{user.displayName}</div>
                        <div className="text-xs text-gray-600">{user.uid}</div>
                      </div>
                    ))}
                  </div> */}

                  <div className="w-full flex items-center justify-between gap-4" >
                    <div className="flex pr-2">
                      {/* <div className="w-[23px] h-full "></div> */}
                      <div className="text-xs text-gray-600">{item.createdAt}</div>
                    </div>

                    <BsTrash3
                      onClick={(e) => {
                        e.stopPropagation();
                        setGroupId(item.id);
                        setName1(item?.users[0]?.displayName);
                        setName2(item?.users[1]?.displayName);
                        setShowDeleteConfirmationPopup(true);
                      }}
                      className='w-3.5 md:w-8 h-3.5 md:h-4 cursor-pointer text-gray-600 hover:text-headPrimary' />
                  </div>

                </div>
              ))}

          </div>
        </div>

        <ModalAnimation showDiv={showDeleteAllConfirmationPop} >
          <div ref={confirmationAllRef} className="relative flex w-[290px] h-fit flex-col items-center p-5 tracking-wide rounded-xl bg-white outline-none dark:bg-navy-800 focus:outline-none">


            <div className="rounded-full bg-red-600 w-12 h-12 p-2.5">
              <BsTrash3 className='h-full w-full text-white' />
            </div>

            <div className="text-xl font-bold text-center mt-4">
              Delete Confirmation
            </div>

            <div className="text-base text-center text-gray-700 mt-1">
              Are you sure you want to Permanently Delete <span className="text-headPrimary">{fetchedGroups.filter((item) => item.isSelected).length} SELECTED</span> chats ?
            </div>

            <button
              onClick={() => { handleGroupDeleteAll() }}
              className="text-base font-bold bg-lightPrimary hover:text-white hover:bg-headPrimary px-5 py-2 rounded-md cursor-pointer mt-6">
              DELETE
            </button>
          </div>
        </ModalAnimation>

        <ModalAnimation showDiv={showDeleteConfirmationPop} >
          <div ref={confirmationRef} className="relative flex w-[290px] h-fit flex-col items-center p-5 tracking-wide rounded-xl bg-white outline-none dark:bg-navy-800 focus:outline-none">


            <div className="rounded-full bg-red-600 w-12 h-12 p-2.5">
              <BsTrash3 className='h-full w-full text-white' />
            </div>

            <div className="text-xl font-bold text-center mt-4">
              Delete Confirmation
            </div>

            <div className="text-base text-center text-gray-700 mt-1">
              Are you sure you want to Permanently Delete Chat between <span className="text-headPrimary">{name1}</span> & <span className="text-headPrimary">{name2}</span> ?
            </div>

            <button
              onClick={() => { handleGroupDelete(groupId) }}
              className="text-base font-bold bg-lightPrimary hover:text-white hover:bg-headPrimary px-5 py-2 rounded-md cursor-pointer mt-6">
              DELETE
            </button>
          </div>
        </ModalAnimation>

      </div>

    )
  else
    return (
      <div className="w-full flex flex-col h-full"></div>
    )
}

export default ManageIndividuals